import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAlertsTopCategoriesRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
});

const GetAlertsTopCategoriesResponseDtoSchema = z.object({
  facility: z.array(
    z.object({
      alertName: z.string(),
      alertPct: z.number(),
    })
  ),
  market: z.array(
    z.object({
      alertName: z.string(),
      alertPct: z.number(),
    })
  ),
});

export type GetAlertsTopCategoriesRequestDto = z.infer<
  typeof _GetAlertsTopCategoriesRequestDtoSchema
>;
export type GetAlertsTopCategoriesResponseDto = z.infer<
  typeof GetAlertsTopCategoriesResponseDtoSchema
>;

export const getAlertTopCategories = (
  params: GetAlertsTopCategoriesRequestDto,
  config?: AxiosRequestConfig<GetAlertsTopCategoriesRequestDto>
) => {
  const { facilityId, ...otherParams } = params;

  return api
    .get(`market-intelligence/facilities/${facilityId}/alert-top-categories`, {
      params: otherParams,
      ...config,
    })
    .then(responseContract(GetAlertsTopCategoriesResponseDtoSchema));
};
